import { useMemo } from "react";
import { useThemeSlice } from "../../../../components/ui/StatusBadge.jsx";
import { DEBUG_ACTIONS } from "./deviceDebugMock.js";
import { buildDebugPanelTokens } from "./deviceDebugTheme.js";

export function DeviceDebugCommands({ onAction }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const tk = useMemo(() => buildDebugPanelTokens(c, dark, A), [c, dark, A]);

  return (
    <div style={{ background: c.card, border: `1px solid ${c.cardBdr}`, borderRadius: tk.radius, padding: "10px 12px", boxShadow: tk.shadowSm, flexShrink: 0 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        <SectionLabel c={c} inline>Commands</SectionLabel>
        <div style={{ display: "flex", alignItems: "center", gap: 6, flex: 1, minWidth: 0, overflowX: "auto", scrollbarWidth: "thin" }}>
          {DEBUG_ACTIONS.positive.map((action) => (
            <ActionButton key={action.id} label={action.label} tokens={tk.positive} onClick={() => onAction?.(action.id)} />
          ))}
          <span aria-hidden style={{ width: 1, height: 20, background: c.divider, flexShrink: 0 }} />
          {DEBUG_ACTIONS.negative.map((action) => (
            <ActionButton key={action.id} label={action.label} tokens={tk.negative} onClick={() => onAction?.(action.id)} />
          ))}
        </div>
      </div>
    </div>
  );
}

function SectionLabel({ c, children, margin = 8, inline = false }) {
  return (
    <div
      style={{
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: c.sub,
        marginBottom: inline ? 0 : margin,
        flexShrink: 0,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </div>
  );
}

function ActionButton({ label, tokens, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        height: 28,
        padding: "0 10px",
        borderRadius: 8,
        border: `1px solid ${tokens.border}`,
        background: tokens.bg,
        color: tokens.text,
        fontSize: 10.5,
        fontWeight: 700,
        cursor: "pointer",
        textAlign: "center",
        lineHeight: 1.25,
        whiteSpace: "nowrap",
        flexShrink: 0,
        transition: "opacity 0.15s ease",
      }}
    >
      {label}
    </button>
  );
}
